module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sr-4ee190817d3b7c7862ca83e56bea902d.svg";